import { Col, Container, Row } from "reactstrap";
import { P } from "../../AbstractElements";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <Container fluid>
        <Row>
          <Col md="12" className="footer-copyright text-center">
            <P className="mb-0">Copyright {year} © Dentopia Marketing</P>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
